import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { Helmet } from "react-helmet";

import { buildEventDate } from "utils/dateTimeUtils";
import InvitePresenter from "presenters/InvitePresenter";
import ThemePresenter from "presenters/ThemePresenter";
import { DEFAULT_INVITE_DETAILS, DEFAULT_INVITE_THEME } from "enums";

import GuestList from "./components/GuestList";
import FieldValue from "./components/FieldValue";
import CollapsableField from "./components/CollapsableField";
import Field from "./components/Field";
import FieldLabel from "./components/FieldLabel";
import { DetailsContainer, Block2Container, HostContainer, EventDate } from "./styles";

const EventDetails = ({ invite = DEFAULT_INVITE_DETAILS, theme = DEFAULT_INVITE_THEME, isGuestView }) => {
  const normalizedTheme = ThemePresenter.normalizeTheme(theme);
  const eventDate = invite.eventDate
    ? buildEventDate(invite.eventDate)
    : buildEventDate(DEFAULT_INVITE_DETAILS.eventDate);

  return (
    <>
      <Helmet>
        <link href={ThemePresenter.fontsLink(theme)} rel="stylesheet" />
        <style>{ThemePresenter.toCSS(normalizedTheme)}</style>
      </Helmet>

      <DetailsContainer
        data-testid="detailsContainer"
        inviteTheme={normalizedTheme}
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <FieldValue field="title" invite={invite} labelVariant="h1" labelComponent="p" />
        <CollapsableField field="host" invite={invite}>
          <HostContainer>
            <Field field="host" labelText="Hosted by " invite={invite} />
          </HostContainer>
        </CollapsableField>
        <FieldValue field="description" invite={invite} />
        <FieldLabel field="date" text="Date" />
        <EventDate>
          <Typography component="span" className="date">
            {eventDate.date}
          </Typography>
          {!invite.allDay && (
            <Typography component="span" className="date">{`${eventDate.time} ${eventDate.zoneAbbr}`}</Typography>
          )}
        </EventDate>
        <CollapsableField field="location" invite={invite}>
          <Field field="location" labelText="Location" invite={invite} />
        </CollapsableField>
      </DetailsContainer>
      <CollapsableField field="details" invite={invite}>
        <Block2Container
          data-testid="block2Container"
          inviteTheme={normalizedTheme}
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Field
            field="details"
            labelText="Event Details"
            invite={invite}
            customClassName="title"
            labelVariant="h1"
            labelComponent="p"
          />
        </Block2Container>
      </CollapsableField>
      <GuestList invite={invite} theme={theme} isGuestView={isGuestView} />
    </>
  );
};

EventDetails.propTypes = {
  invite: InvitePresenter.shape(),
  theme: ThemePresenter.shape(),
  isGuestView: PropTypes.bool,
};

export default EventDetails;
